module.exports = __webpack_public_path__ + "img/photoshop.0807c3eb.svg";